// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2EOK7","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3y9zv"};